@if (location(); as location) {
  <avs-locations-map [locations]="[location]" />
} @else {
  <ngx-skeleton-loader [theme]="{ height: '100%' }" />
}
